import dayjs from 'dayjs';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Agreements } from '../../../../types/Agreements.types';
import { TableCell, TableRow } from '@mui/material';
import { StyledStatusChip } from './AgreementsList';

type AgreementsTableRowProps = {
  agreement: Agreements;
  onRowClick: (agreementId: string) => void;
};

export const AgreementsTableRow = ({
  agreement,
  onRowClick,
}: AgreementsTableRowProps) => {
  const { t } = useTranslation();
  const handleRowKeyDown = (e: React.KeyboardEvent<HTMLTableRowElement>) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      onRowClick(agreement._id!);
    }
  };

  const rowLabel = t('agreements.editAgreementRow', { name: agreement.name });

  return (
    <TableRow
      key={agreement._id}
      onClick={() => onRowClick(agreement._id!)}
      tabIndex={0}
      aria-label={rowLabel}
      onKeyDown={handleRowKeyDown}
      sx={{
        cursor: 'pointer',
        '&:focus-visible': {
          outline: '2px solid var(--color-scifree-teal)',
          outlineOffset: '-2px',
        },
      }}
    >
      <TableCell align="left" width="20%">
        {agreement.publisher}
      </TableCell>
      <TableCell align="left" width="20%">
        {agreement.name}
      </TableCell>
      <TableCell align="left" width="20%">
        {agreement.start_date
          ? dayjs(agreement.start_date).format('YYYY-MM-DD')
          : '-'}
      </TableCell>
      <TableCell align="left" width="20%">
        {agreement.end_date
          ? dayjs(agreement.end_date).format('YYYY-MM-DD')
          : '-'}
      </TableCell>
      <TableCell align="left" width="10%">
        <StyledStatusChip
          status={agreement.computed_status}
          size="small"
          label={agreement.computed_status || '-'}
          sx={{ margin: 'auto' }}
        />
      </TableCell>
      <TableCell align="left" width="10%">
        {agreement.journals_count}
      </TableCell>
    </TableRow>
  );
};
